import { Group, Text } from '@mantine/core';

export const Logo = () => {
  return (
    <Group>
      <svg width="35" height="40" viewBox="0 0 35 40" fill="none">
        <path
          d="M17.5398 12.9585L11.6284 16.3606V23.1715L17.5398 26.5871L23.4511 23.1715V16.3606L17.5398 12.9585Z"
          fill="white"
        ></path>
        <path d="M0.711426 30.5444L17.086 39.9999L22.5442 30.5444H0.711426Z" fill="white"></path>
        <path d="M0.522949 9.71957L5.71736 18.7286L16.1129 0.717285L0.522949 9.71957Z" fill="white"></path>
        <path d="M12.5356 9.00905H33.3065L17.7368 0L12.5356 9.00905Z" fill="white"></path>
        <path d="M24.3574 10.0503L34.7462 28.0616V10.0503H24.3574Z" fill="white"></path>
        <path d="M29.3493 20.8184L18.9673 38.8297L34.5437 29.8274L29.3493 20.8184Z" fill="white"></path>
        <path d="M0.333496 29.4962H10.7223L0.333496 11.4849V29.4962Z" fill="white"></path>
      </svg>
      <Text>Constellation</Text>
    </Group>
  );
};
